import React, { Fragment, useEffect, useState, useContext } from 'react'
import { UrlServicesContext } from '../UrlServicesContext'
import { Redirect } from 'react-router-dom'

import { Alert, Skeleton, Autocomplete } from '@material-ui/lab'
import { Box, Grid, TextField } from '@material-ui/core'
import axios from 'axios'

export default function LoadJobs(props) {
  const [results, setResults] = useState(null)
  const [error, setError] = useState(false)
  const [isLoadedd, setIsLoadedd] = useState(false)
  const [returnLogin, setReturnLogin] = React.useState(false)

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  useEffect(() => {
    const consultar = async () => {
      await axios
        .get(
          `${urlServices}jobs/account/${localStorage.getItem('account_id')}`,
          {
            headers: {
              application: keyAplication,
              Authorization: 'Bearer ' + keyAuthorization,
            },
          }
        )
        .then((response) => {
          setResults(response.data)
          setIsLoadedd(true)
        })
        .catch((e) => {
          if (e.response.status === 401) {
            console.log(e)

            setTimeout(() => {
              localStorage.clear()
              setReturnLogin(true)
            }, 200)
          } else {
            console.log(e)
            setResults(null)
            setError(true)
            setIsLoadedd(false)
          }
        })
    }
    consultar()
  }, [urlServices, keyAplication])

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      {error && (
        <Alert severity="error">
          Error en la consulta de <b>CARGOS</b>
        </Alert>
      )}
      {!isLoadedd ? (
        <Fragment>
          <Grid item xs={12} sm={12}>
            <center>
              <Box sx={{ width: '100%' }}>
                <Skeleton width="100%" height={35} />
              </Box>
            </center>
          </Grid>
        </Fragment>
      ) : (
        <Autocomplete
          id="combo-box-demo"
          options={results}
          value={props.value}
          onChange={(event, newValue) => {
            props.refresh(newValue)
          }}
          getOptionLabel={(option) => option.name || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Cargo"
              variant="standard"
              error={props.error}
              required
            />
          )}
        />
      )}
    </Fragment>
  )
}
